<app-loadable-content [loadingController]="userLoadingController" (onRetry)="loadUser()">
    <app-title>{{ user.name }} {{ user.lastName }}</app-title>
    <div align="center">
        <app-toolbar [subject]="user" [actions]="userToolbarModel.actions" [compactActions]="userToolbarModel.compactActions"></app-toolbar>
    </div>
    <p>
        {{ 'email' | translate }}: {{user.email}}
    </p>
</app-loadable-content>
